import { getCurrentPageUrl } from "../../util/request-uri"
import StarsExclusivePost from "./StarsExclusivePost.js?v=1"
import StarsPostGallery from "./StarsPostGallery.js"
import StarsPostsComments from "./StarsPostsComments.js"
import StarsPostsLikes from "./StarsPostsLikes.js"
import StarsPostsRoses from "./StarsPostsRoses.js"
import { initializeSwipers } from "./StarsSwiper.js"
import "../../captcha/friendly-captcha.js"
import { addReportStarPostClickEvents } from "../../form/report-star-post/report-add-click-event.ts"
import { starsPostFilterMenu, starsPostFooterButton, starsPostFooterButtonEmpty } from "./templates"

export default class StarsPost {
    /**
     * @property {string} StarsPosts.apiBaseUrl
     * @property {boolean} StarsPosts.isMobile
     * @property {boolean} StarsPosts.isYourPostsPage
     * @property {string} StarsPosts.ownerId
     *
     * @property {HTMLElement} LadiesPosts.loadAdditionalPostsButton
     * @property {HTMLElement} LadiesPosts.reportPostModal
     * @property {FormData} LadiesPosts.alreadySeenPostsRequestFormData
     * @property {FormData} LadiesPosts.postOrderFormData
     * @property {Array} LadiesPosts.postIdList
     * @property {Array} LadiesPosts.seenPostIds
     */
    constructor(/** jQuery */ jQuery) {
        this.starsPostContainer = document.getElementById("stars-post-container")
        this.starsPosts = document.createElement("div")
        this.starsPostFooter = document.getElementById("stars-post-footer")

        if (!this.starsPostContainer) {
            return
        }

        this.starsPostContainer.appendChild(this.starsPosts)

        initializeSwipers().then()
        this.postGallery = new StarsPostGallery(this.starsPostContainer)
        this.postsLikes = new StarsPostsLikes(jQuery)
        this.postsRoses = new StarsPostsRoses(jQuery)
        this.postsComments = new StarsPostsComments(this)

        this.apiBaseUrl = SiteInfo.yiiLadiesApiUrl
        this.isMobile = SiteInfo.isMobileVersion
        this.isYourPostsPage = document.location.pathname === "/stars/deine-posts"
        this.isAdvertDetailPage = false
        this.initializeAdvertDetailPage()

        const creatorIdData = document.getElementById("data-creator-ids")

        this.ownerIds = null
        if (creatorIdData) {
            const htmlValue = document.getElementById("data-creator-ids").getAttribute("value")

            // expect parsable values to be json arrays and non-parsable values to be single values from advert page
            try {
                this.ownerIds = JSON.parse(htmlValue)
            } catch {
                this.ownerIds = htmlValue
            }
        }

        this.reportPostModal = document.getElementById("report-post-modal")

        this.alreadySeenPostsRequestFormData = new FormData()
        this.alreadySeenPostsRequestFormData.append("creatorId", this.ownerIds)

        const seenPostsJson = document.getElementById("ordered-post-metadata")?.value || ""
        this.postOrderFormData = new FormData()
        this.postOrderFormData.append("postOrder", seenPostsJson)

        this.postIdList = []
        this.seenPostIds = []
        this.filterTypeForFans = "for-fans"
        this.filterTypePurchased = "freigeschaltet"
        this.filterTypePurchasable = "freischaltbar"
        this.filterTypeAll = "alle"
        this.starPostsFilterType = "alle"
        this.addStarsContentEventListeners()
    }

    loadCurrentStarsPostsFilterForMyPosts() {
        if (SiteInfo.accessToken === "") {
            return
        }

        // this.filterPosts(this.filterTypeAll)
        this.addEventListenersForFilterButtons()
        this.addLoadPostsButtonEventListener()
        this.removeCurrentStarsPostFilter()
        new StarsExclusivePost(this)
    }

    loadCurrentStarsPostsFilterForStarsProfile() {
        this.starPostsFilterType = this.filterTypeAll
        this.loadPostForStarProfile().then((r) => {
            new StarsExclusivePost(this)
            addReportStarPostClickEvents()
        })
        this.removeCurrentStarsPostFilter()
    }

    addStarsContentEventListeners() {
        /** void */
        $(this.reportPostModal).on("show.bs.modal", (/** jQuery.Event */ modalEvent) =>
            this.toggleFansReportPostModalContent(modalEvent),
        )

        const starsPostElements = document.querySelectorAll(".stars-post")

        for (const post of starsPostElements) {
            this.postsLikes.listenForLikesInteraction(post)
            this.postsRoses.listenForRosesInteraction(post)
        }

        window.addEventListener("hashchange", () => {
            this.clearStarsPostContainer()
            this.markActiveFilter()
        })
    }

    async loadPostForStarProfile() {
        if (this.starsPostContainer === null) {
            return
        }

        this.cleanStarsPostContainer()
        this.cleanStarsPostFooter()

        if (this.ownerIds === null) {
            return
        }

        let response = await fetch(
            `/api/stars-profile/${this.starPostsFilterType}?isMobile=${this.isMobile}&creatorId=${this.ownerIds}`,
            {
                method: "GET",
                credentials: "include",
            },
        )
        response = await response.json()

        this.starsPostContainer.innerHTML = response["filter"]

        if (response["noFurtherPosts"] && response["postCount"] > 0) {
            this.starsPostFooter.innerHTML = starsPostFooterButtonEmpty()
        }

        if (!response["noFurtherPosts"]) {
            this.starsPostFooter.innerHTML = starsPostFooterButton()
        }

        if (response["noFurtherPosts"] && response["postCount"] === 0) {
            this.starsPostFooter.innerHTML = ""
        }

        const nodes = this.convertHtmlStringAsListOfNodes(response["posts"])

        this.addPosts(nodes)
        this.setActiveFilter(this.starPostsFilterType)
        this.addEventListenersForFilterButtons()
        this.addLoadPostsButtonEventListener()
    }

    addLoadPostsButtonEventListener() {
        document.getElementById("load-posts-btn")?.addEventListener("click", () => {
            this.loadAdditionalPosts()
        })
    }

    addEventListenersForFilterButtons() {
        const postsFilterAll = document.getElementById("postsFilterAll")

        if (postsFilterAll === null) {
            return
        }

        postsFilterAll.addEventListener("click", () => {
            this.filterPosts(this.filterTypeAll)
        })

        const postsFilterFans = document.getElementById("postsFilterForFans")
        postsFilterFans.addEventListener("click", () => {
            this.filterPosts(this.filterTypeForFans)
        })

        const postsFilterPurchased = document.getElementById("postsFilterPurchased")
        postsFilterPurchased.addEventListener("click", () => {
            this.filterPosts(this.filterTypePurchased)
        })

        const postsFilterPurchasable = document.getElementById("postsFilterPurchasable")
        postsFilterPurchasable.addEventListener("click", () => {
            this.filterPosts(this.filterTypePurchasable)
        })
    }

    async filterPosts(filterType) {
        this.starPostsFilterType = filterType

        let url = `/api/posts/${this.starPostsFilterType}?isMobile=${this.isMobile}`

        if (this.ownerIds !== "" && this.ownerIds.length !== 0) {
            url = url + `&creatorId=${this.ownerIds}`
        }

        let response = await fetch(url, {
            method: "GET",
            credentials: "include",
        })

        response = await response.json()

        this.cleanStarsPostContainer()
        this.cleanStarsPostFooter()

        if (response["noFurtherPosts"] && response["postCount"] > 0) {
            this.starsPostFooter.innerHTML = starsPostFooterButtonEmpty()
        }

        if (response["noFurtherPosts"] && response["postCount"] === 0) {
            this.starsPostFooter.innerHTML = ""
        }

        if (!response["noFurtherPosts"]) {
            this.starsPostFooter.innerHTML = starsPostFooterButton()
            this.addLoadPostsButtonEventListener()
        }

        const nodes = this.convertHtmlStringAsListOfNodes(response["posts"])
        this.addPosts(nodes)
        this.setActiveFilter(filterType)
        this.scrollToFilterPosition()
    }

    scrollToFilterPosition() {
        const container = document.querySelector(".slidemenu-stars-filter")
        const activeEl = container?.querySelector(".active")

        if (container && activeEl) {
            const scrollTo = activeEl.offsetLeft - container.offsetWidth / 2 + activeEl.offsetWidth / 2

            container.scrollTo({
                left: scrollTo,
                behavior: "smooth",
            })
        }
    }

    cleanStarsPostContainer() {
        const fansPostContainer = document.getElementById("stars-post-container")
        const posts = fansPostContainer.querySelectorAll("div.stars-post")
        for (let i = 0; i < posts.length; i++) {
            posts[i].remove()
        }

        const cards = fansPostContainer.querySelectorAll("div.lavert-card")
        for (let i = 0; i < cards.length; i++) {
            cards[i].remove()
        }

        const notLoggedIn = fansPostContainer.querySelectorAll("div.notLoggedInContainer")
        for (let i = 0; i < notLoggedIn.length; i++) {
            notLoggedIn[i].remove()
        }
    }

    cleanStarsPostFooter() {
        const starsPostFooter = document.getElementById("stars-post-footer")
        if (starsPostFooter === null) {
            return
        }
        starsPostFooter.innerHTML = ""
    }

    setActiveFilter(filterType) {
        let filterId = "alle"

        if (filterType === "" || filterType === this.filterTypeAll) {
            filterId = "postsFilterAll"
        }

        if (filterType === this.filterTypeForFans) {
            filterId = "postsFilterForFans"
        }

        if (filterType === this.filterTypePurchased) {
            filterId = "postsFilterPurchased"
        }

        if (filterType === this.filterTypePurchasable) {
            filterId = "postsFilterPurchasable"
        }

        const filterLinks = document.querySelectorAll(".slidemenu-stars-filter a")

        for (let i = 0; i < filterLinks.length; i++) {
            filterLinks[i].classList.remove("active")
        }

        const targetLink = document.getElementById(filterId)
        if (targetLink) {
            targetLink.classList.add("active")
        }
    }

    toggleFansReportPostModalContent(event) {
        /** void */
        const postId = event.relatedTarget.dataset.postId

        const firstImageInPost = document.querySelector(`#post-${postId} .report-advert-thumbnail:first-child`)
        let postImageSrc

        if (firstImageInPost) {
            postImageSrc = firstImageInPost.src
        }

        if (!postImageSrc) {
            // If first image is not found, it means the first image is a video and our html is simply fucked up
            const firstVideoInPost = document.querySelector(`#post-${postId} .video-wrapper img.hidden-poster-image`)
            postImageSrc = firstVideoInPost.src
        }

        const postDescription = document.querySelector(`#post-${postId} .post-description`).innerText

        const reportModalImage = document.querySelector("#report-post-modal .report-advert-thumbnail")
        reportModalImage.setAttribute("src", postImageSrc)

        if (postDescription !== "") {
            const reportModalDescription = document.querySelector("#report-post-modal .report-advert-description")
            reportModalDescription.innerText = postDescription
        }

        document.querySelector("#report-post-modal .report-post-id").value = postId
        document.querySelector("#report-post-modal .report-creator-id").value = event.relatedTarget.dataset.ownerId
    }

    async loadAdditionalPosts() /** Promise<void> */ {
        const loadButton = document.getElementById("load-posts-btn")
        if (loadButton) {
            loadButton.innerText = "Lädt..."
        }

        const ladiesAdvertCards = document.getElementsByClassName("lavert-card")
        const lastPostId = ladiesAdvertCards[ladiesAdvertCards.length - 1]?.id?.substring(5) || ""

        if (lastPostId === "") {
            return
        }

        let url = `/api/posts/${this.starPostsFilterType}?isMobile=${this.isMobile}&lastPostId=${lastPostId}`

        if (this.ownerIds !== "" && this.ownerIds.length !== 0) {
            url = url + `&creatorId=${this.ownerIds}`
        }

        /** @type {StarsPostApiResponse} */
        let response = await fetch(url, {
            method: "GET",
            credentials: "include",
        })

        response = await response.json()

        if (lastPostId === "" && !this.filterButtons) {
            const filterMenu = starsPostFilterMenu(getCurrentPageUrl(), response.filterCounts)

            this.clearStarsPostContainer()
            this.starsPostContainer.prepend(filterMenu)
            this.filterButtons = this.starsPostContainer.querySelectorAll(".stars-filter-container a")

            this.markActiveFilter()
        }

        const nodes = this.convertHtmlStringAsListOfNodes(response.posts)
        this.addPosts(nodes)

        if (!response.noFurtherPosts) {
            addReportStarPostClickEvents()
            document.getElementById("load-posts-btn").innerText = "Mehr Beiträge laden"
        } else {
            document.getElementById("load-posts-btn").innerText = "Done"
            this.starsPostFooter.innerHTML = starsPostFooterButtonEmpty()
        }
    }

    getCurrentStarsPostFilter() {
        const hashValues = new URLSearchParams(window.location.hash.substring(1))
        return hashValues.get("starPosts") || ""
    }

    removeCurrentStarsPostFilter() {
        const hashValues = new URLSearchParams(window.location.hash.substring(1))
        hashValues.delete("starPosts")

        if (hashValues.toString().length === 0) {
            // Remove the hash completely
            history.replaceState(null, "", window.location.pathname + window.location.search)
        } else {
            // Update to remaining hash
            history.replaceState(
                null,
                "",
                window.location.pathname + window.location.search + "#" + hashValues.toString(),
            )
        }
    }

    clearStarsPostContainer() {
        this.starsPosts.innerText = ""
    }

    markActiveFilter() {
        if (!this.filterButtons) {
            return
        }

        const activeFilter = this.starsPostContainer.querySelector(
            `.stars-filter-container a[href*="starPosts=${this.getCurrentStarsPostFilter()}"]`,
        )

        requestAnimationFrame(() => {
            for (const filterButton of this.filterButtons) {
                filterButton.classList.remove("active")
            }

            if (activeFilter) {
                activeFilter.classList.add("active")
            }
        })
    }

    addPosts(/** NodeListOf<HTMLElement> */ posts) /** void */ {
        for (const post of posts) {
            this.starsPostContainer.appendChild(post)
            this.postsLikes.listenForLikesInteraction(post)
            this.postsRoses.listenForRosesInteraction(post)
            this.postsComments.listenForCommentsInteraction(post)
        }

        this.initializeScriptsForNewPosts()
    }

    convertHtmlStringAsListOfNodes(/** string */ nodeString) {
        /** NodeListOf<HTMLElement> */
        const parser = new DOMParser()
        const fansPostHtml = parser.parseFromString(nodeString, "text/html")

        return fansPostHtml.documentElement.querySelectorAll("div.stars-post, .lavert-card-separator")
    }

    initializeScriptsForNewPosts() {
        /** void */
        initializeSwipers()
        this.postGallery.initializeGalleries()
        this.initializeDropdownCloseEvents()
    }

    initializeAdvertDetailPage() {
        const advertDetailPageBody = document.getElementById("einzelansicht")
        if (typeof advertDetailPageBody !== "undefined" && advertDetailPageBody !== null) {
            this.isAdvertDetailPage = true
        }
    }

    initializeDropdownCloseEvents() {
        const dropdownMenu = document.querySelectorAll(".dropdown-menu")
        const dropdownCollapse = (collapseEvent, menu) => {
            $(document).on("click touchend", (e) => {
                const buttonElement = $(e.target).closest(".dropdown-menu")
                if (buttonElement.hasClass(".in")) {
                    return
                }

                menu.collapse("hide")
            })
        }

        for (const menu of dropdownMenu) {
            const $menu = $(menu)
            $menu.on("show.bs.collapse", (collapseEvent) => dropdownCollapse(collapseEvent, $menu))
            $menu.off("show.bs.collapse", (collapseEvent) => dropdownCollapse(collapseEvent, $menu))
        }
    }
}
